var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5RelatedFindings = function SvgAv5RelatedFindings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-variant": "button-icon",
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Z",
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "color-override",
    "data-no-fill": "true",
    x: 13,
    y: 13.7,
    width: 1.3,
    height: 8,
    rx: 0.65,
    transform: "rotate(90 13 13.7)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "color-override",
    "data-no-fill": "true",
    x: 10.444,
    y: 9.4,
    width: 1.3,
    height: 5.444,
    rx: 0.65,
    transform: "rotate(90 10.444 9.4)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "color-override",
    "data-no-fill": "true",
    x: 13,
    y: 5.1,
    width: 1.3,
    height: 8,
    rx: 0.65,
    transform: "rotate(90 13 5.1)",
    fill: "#fff"
  })));
};
export { SvgAv5RelatedFindings as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLXZhcmlhbnQ9ImJ1dHRvbi1pY29uIiB2aWV3Qm94PSIwIDAgMTkgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNOS41IDE5LjVDMTQuNzQ2NyAxOS41IDE5IDE1LjI0NjcgMTkgMTBDMTkgNC43NTMyOSAxNC43NDY3IDAuNSA5LjUgMC41QzQuMjUzMjkgMC41IDAgNC43NTMyOSAwIDEwQzAgMTUuMjQ2NyA0LjI1MzI5IDE5LjUgOS41IDE5LjVaIgogICAgICAgICAgZmlsbD0iIzAwMCIvPgogICAgPHJlY3QgY2xhc3M9ImNvbG9yLW92ZXJyaWRlIiBkYXRhLW5vLWZpbGw9InRydWUiIHg9IjEzIiB5PSIxMy43IiB3aWR0aD0iMS4zIiBoZWlnaHQ9IjgiIHJ4PSIwLjY1IgogICAgICAgICAgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMTMgMTMuNykiCiAgICAgICAgICBmaWxsPSJ3aGl0ZSIvPgogICAgPHJlY3QgY2xhc3M9ImNvbG9yLW92ZXJyaWRlIiBkYXRhLW5vLWZpbGw9InRydWUiIHg9IjEwLjQ0NDMiIHk9IjkuMzk5OTUiIHdpZHRoPSIxLjMiIGhlaWdodD0iNS40NDQ0NCIgcng9IjAuNjUiCiAgICAgICAgICB0cmFuc2Zvcm09InJvdGF0ZSg5MCAxMC40NDQzIDkuMzk5OTUpIgogICAgICAgICAgZmlsbD0id2hpdGUiLz4KICAgIDxyZWN0IGNsYXNzPSJjb2xvci1vdmVycmlkZSIgZGF0YS1uby1maWxsPSJ0cnVlIiB4PSIxMyIgeT0iNS4wOTk4OCIgd2lkdGg9IjEuMyIgaGVpZ2h0PSI4IiByeD0iMC42NSIKICAgICAgICAgIHRyYW5zZm9ybT0icm90YXRlKDkwIDEzIDUuMDk5ODgpIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";